var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOilContent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 5,
    fill: "#FDEDCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1441 4.84479C12.723 4.12632 12.277 4.15109 11.8559 4.84479C9.92342 7.71866 7 12.0295 7 14.1849C7 15.6961 7.61937 17.0835 8.61036 18.0745C9.60135 19.0655 10.9887 19.6849 12.5 19.6849C14.0113 19.6849 15.3986 19.0655 16.3896 18.0745C17.3806 17.0835 18 15.6961 18 14.1849C18 12.0047 15.0766 7.71866 13.1441 4.84479ZM16.464 16.6376C16.0676 17.2817 15.4977 17.8516 14.8041 18.2479C14.482 18.4214 14.0856 18.3223 13.9122 18.0002C13.714 17.6534 13.8378 17.257 14.1599 17.0835C14.6554 16.811 15.0518 16.4146 15.3491 15.9439C15.6464 15.4732 15.8198 14.9281 15.8446 14.3583C15.8694 13.9867 16.1667 13.7142 16.5383 13.7389C16.9099 13.7637 17.1824 14.061 17.1577 14.4326C17.1081 15.2254 16.8604 15.9687 16.464 16.6376Z",
    fill: "#FCAA0B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilContent);
export default __webpack_public_path__ + "static/media/oil-content.15763645.svg";
export { ForwardRef as ReactComponent };